/**
 * Player Ratings - Scroll Animations
 *
 * Staggered reveal animation for rating rows using Intersection Observer
 */

class PlayerRatingsAnimations {
	constructor() {
		this.container = document.querySelector('.is-style-player-ratings');

		if (!this.container) return;

		this.rows = this.container.querySelectorAll('.player-ratings__row');
		this.levels = this.container.querySelectorAll('.player-ratings__level');
		this.header = this.container.querySelector('.player-ratings__header');

		this.init();
	}

	init() {
		// Mark elements for animation
		this.rows.forEach((row) => row.setAttribute('data-animate', ''));
		this.levels.forEach((level) => level.setAttribute('data-animate', ''));

		if (this.header) {
			this.header.setAttribute('data-animate', '');
		}

		// Set up observers
		this.observeHeader();
		this.observeRows();
		this.observeLevels();
	}

	/**
	 * Fade in header when visible
	 */
	observeHeader() {
		if (!this.header) return;

		const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							entry.target.classList.add('is-visible');
							observer.unobserve(entry.target);
						}
					});
				},
				{
					threshold: 0.2,
				},
		);

		observer.observe(this.header);
	}

	/**
	 * Staggered reveal for rating rows
	 */
	observeRows() {
		if (!this.rows.length) return;

		const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							// Get row index for stagger delay
							const index = Array.from(this.rows).indexOf(entry.target);
							const delay = index * 50; // 50ms stagger

							setTimeout(() => {
								entry.target.classList.add('is-visible');
							}, delay);

							observer.unobserve(entry.target);
						}
					});
				},
				{
					threshold: 0.1,
					rootMargin: '0px 0px -50px 0px',
				},
		);

		this.rows.forEach((row) => observer.observe(row));
	}

	/**
	 * Staggered reveal for level markers
	 */
	observeLevels() {
		if (!this.levels.length) return;

		const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							const index = Array.from(this.levels).indexOf(entry.target);
							const delay = index * 100; // 100ms stagger

							setTimeout(() => {
								entry.target.classList.add('is-visible');
							}, delay);

							observer.unobserve(entry.target);
						}
					});
				},
				{
					threshold: 0.2,
				},
		);

		this.levels.forEach((level) => observer.observe(level));
	}
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		new PlayerRatingsAnimations();
	});
} else {
	new PlayerRatingsAnimations();
}

export default PlayerRatingsAnimations;
